import { translate } from '~l10n/client';
import { AxiosError } from 'axios';

import { toast } from '~shared/components/Toast';
import {
  TeacherApplicationContext,
  useTeacherApplicationContext,
} from '~shared/context/TeacherApplicationContext';
import { useSocrativeRouter } from '~teacher/context/RouterContext';

export function useHandleJoinWorkspaceError() {
  const appContext = useTeacherApplicationContext();
  const router = useSocrativeRouter();

  type JoinWorkspaceErrorCode = 'assessment_mismatch' | 'region_mismatch';

  const joinWorkspaceErrorMessages: Record<JoinWorkspaceErrorCode, string> = {
    assessment_mismatch:
      appContext === TeacherApplicationContext.Socrative
        ? translate('This Showbie join code is not valid in Socrative')
        : translate('This Socrative join code is not valid in Showbie'),
    region_mismatch: translate('Code does not work in your region'),
  };

  return function handleJoinWorkspaceError(error: AxiosError) {
    if (__DEV__) console.error(error);

    const status = error.response?.status;
    const code = error.response?.data?.code as
      | JoinWorkspaceErrorCode
      | undefined;

    if (status === 422) {
      toast.critical(
        translate(
          'Failed to join the library due to membership capacity being reached.'
        )
      );

      router.routeToLaunch();
    } else if (status === 429) {
      toast.critical(translate('You’re joining too fast. Please wait a bit.'));
    } else if (code && code in joinWorkspaceErrorMessages) {
      toast.critical(joinWorkspaceErrorMessages[code]);
    } else {
      toast.critical(translate('Invalid Code.'));
    }
  };
}
